import * as yup from 'yup';

const emailValidator = yup.string().email().nullable();

export const validateEmail = (email: string): boolean => {
  if (!email || email.trim() === '') {
    return false;
  }
  
  try {
    emailValidator.validateSync(email);
    
    return true;
  } catch {
    return false;
  }
};
